import { FunctionComponent, ReactNode } from "react";
import { Navigate } from "react-router";

import { RouteConstants } from "../../../models/enums";
import { useStore } from "../../../stores/StoreContext";

interface IBudgetGuardProps {
  children: ReactNode;
}

export const BudgetGuard: FunctionComponent<IBudgetGuardProps> = ({ children }) => {
  const { budgetStore } = useStore();

  if (!budgetStore.hasBudget) {
    return <Navigate to={`/${RouteConstants.NoBudget}`} replace />;
  }

  return children;
};
